import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { useDeleteTopologyMutation } from '../../../../redux/topologies/api';
import {
  clearTopologyToDelete,
  setShouldConfirmDelete,
  topologiesSelectors,
} from '../../../../redux/topologies/slice';
import { RootState } from '../../../../redux/store';
import { DeleteTopologyModal, DeleteTopologyModalProps } from '.';

export type PropsFromRedux = ReturnType<typeof mapStateToProps>;

type DeleteTopologyModalContainerProps = Pick<
  DeleteTopologyModalProps,
  'clearTopologyToDelete' | 'topologyToDelete' | 'setShouldConfirmDelete'
>;

const mapStateToProps = (state: RootState) => ({
  topologyToDelete: topologiesSelectors.getTopologyToDelete(state),
});

const mapDispatchToProps = {
  clearTopologyToDelete,
  setShouldConfirmDelete,
};

function DeleteTopologyModalContainer({
  clearTopologyToDelete,
  topologyToDelete,
  setShouldConfirmDelete,
}: DeleteTopologyModalContainerProps): ReactElement {
  const [deleteTopology, { isLoading: isDeleting }] =
    useDeleteTopologyMutation();

  return (
    <DeleteTopologyModal
      clearTopologyToDelete={clearTopologyToDelete}
      deleteTopology={() => deleteTopology(topologyToDelete!.uid)}
      isDeleting={isDeleting}
      setShouldConfirmDelete={setShouldConfirmDelete}
      topologyToDelete={topologyToDelete}
    />
  );
}

export const ConnectedDeleteTopologyModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteTopologyModalContainer);
